export default "__VITE_ASSET__411a6f62__"